import React from "react";
import "./InstructionSection.css";

function InstructionSection({ 
  title, 
  icon = "📋",
  children,
  className = "" 
}) {
  return (
    <div className={`instruction-section ${className}`}>
      <h3 className="instruction-section-title">
        <span className="instruction-icon">{icon}</span>
        {title}
      </h3>
      <div className="instruction-content">
        {children}
      </div>
    </div>
  );
}

export default InstructionSection;

